import { CatPrimaryNav } from '@blocks-react/components/PrimaryNav';
import { PAGE_BREAKPOINTS } from '../../../constants/commonConstants';
import { CSSProperties, FC, PropsWithChildren } from 'react';

type SubHeaderPrimaryProps = {
  className?: string;
  isCollapsed?: boolean;
  moreDropdownLabel: string;
  style?: CSSProperties;
  mobileBreakPoint?: number;
};

export const SubheaderPrimaryNav: FC<
  PropsWithChildren<SubHeaderPrimaryProps>
> = ({ children, className, isCollapsed, moreDropdownLabel, style, mobileBreakPoint = PAGE_BREAKPOINTS.BLOCKS_LG }) => {
  return (
    <CatPrimaryNav
      behavior="more"
      className={className}
      data-testId="subheader-primary-nav"
      isCollapsed={isCollapsed}
      moreDropdownLabel={moreDropdownLabel}
      style={style}
      mobileBreakPoint={mobileBreakPoint}
    >
      {children}
    </CatPrimaryNav>
  );
};
